/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { countResponseSchema } from '../campaign-schema';

export const getCampaignPostsCountPathSchema = z.object({
  campaignId: z.string(),
});

export const getCampaignPostsCountOperationResponseSchema = countResponseSchema;

export type GetCampaignPostsCountInput = {
  path: z.input<typeof getCampaignPostsCountPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignPostsCount({
  path,
  signal,
}: GetCampaignPostsCountInput): Promise<
  z.infer<typeof getCampaignPostsCountOperationResponseSchema>
> {
  const parsedPath = getCampaignPostsCountPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/posts/count`,
    {
      signal,
    },
  );
  return getCampaignPostsCountOperationResponseSchema.parse(
    await response.json(),
  );
}
